// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"9d625772","213":"513dee1f","329":"c07039c9","337":"5ebdae15","339":"669f2d7c","453":"97621859","549":"d7ec2157","674":"b7f7932f","813":"17a19885","913":"99194ce3"}[chunkId] + ".chunk.js";
};